import { render, staticRenderFns } from "./gross-profit-product.vue?vue&type=template&id=719dbb72"
import script from "./gross-profit-product.vue?vue&type=script&lang=js"
export * from "./gross-profit-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports